











































import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { State, Action, Getter } from "vuex-class";
import VJsonschemaForm from '@pan-gms/vuetify-jsonschema-form';
import NavigationButtons from "./NavigationButtons.vue";
import 'vuetify/dist/vuetify.min.css'
import '@pan-gms/vuetify-jsonschema-form/dist/main.css';
import { http as _http } from '@/shared/https';
import { Workspace } from "@/entities";
import { Locales } from "@/i18n/locales";

const namespace: string = "conceptNote";

@Component({
    components: {
        NavigationButtons,
        VJsonschemaForm
    }
})
export default class SafeguardComponent extends Vue {

  @Prop() appData!: any;
  @Prop() readOnly: boolean;
  @Getter("rootTemplate", { namespace }) schema: any;
  @State(namespace) app!: Workspace;
  @Action("uploadDocument", { namespace }) uploadDocument: any;

  /** declare variables */
  formValid: boolean = false;
  isDirty: boolean = false;
  renderComponent: boolean = true;
  data: any = {};
  schemaformKey: number = 0;
  id: number;
  defaultLocale: string = localStorage.getItem("language") || Locales.EN;

  get options() {
    return {
      disableAll: (this.readOnly && this.readOnly === true) ? true : false,
      "uploadAction": this.uploadDocument,
      "removeAction": this.$services.document.removeDocument,
      "downloadAction": this.$services.document.download,
      "locale": this.defaultLocale,
      "ApplicationId": this.app.conceptNote.ConceptNoteId,
      "httpLib": _http,
      "baseURI": process.env.VUE_APP_API_Base_URL,
      "fileSizeLimit": this.appSettings.MaxFileSizeLimit
    }
  }


  /** top menu change event */
  topMenuChanged(key) {
    this.$emit("change", key);
  }

  /** error event */
  showError(err) {
    window.alert(err);
  }

  /** change event */
  showChange(e) {
    this.isDirty = true;
    this.$emit("input", true);
    // console.log('"change" event', e)
  }

  /** input event */
  showInput(e) {
    this.isDirty = true;
    this.$emit("input", true);
    // console.log('"input" event', e)
  }

  /** application data */
  get datum(): any {
    return this.appData;
  }

  get subSchema(): any {
      if(this.schema && this.schema.properties && this.schema.properties.managementSystem) {
          return this.schema.properties.managementSystem;
      } else {
          return null;
      }
  }

  /** get the section title */
  get sectionTitle() {
    if(this.subSchema)
      return this.subSchema.title;
    else
      return '';
  }

  /** watch state and update the variable */
  @Watch("appData")
  onDataChanged(value: any, oldValue: any) {
    this.schemaformKey += 1;
  }
    
}
